export const PRICE_FOR_FREE_SHIPPING = 99;
